import AgeCheckModal from './AgeCheckModal';

export default AgeCheckModal;
